import service from '@/utils/request';
export var saveRoleClear = function saveRoleClear(data) {
  return service({
    url: "/xcpOpsManager/saveRoleClear",
    method: 'post',
    data: data
  });
};
export var getRoleClearList = function getRoleClearList(data) {
  return service({
    url: "/xcpOpsManager/getRoleClearList",
    method: 'post',
    data: data
  });
};
export var approveRoleClear = function approveRoleClear(data) {
  return service({
    url: "/xcpOpsManager/approveRoleClear",
    method: 'post',
    data: data
  });
};